if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    // NUEVO: Getter para asegurar que siempre tengamos referencia al botón
    get submitButton() {
      return this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      
      // CAMBIO: Validar que el botón existe antes de usarlo
      const submitBtn = this.submitButton;
      if (!submitBtn) {
        console.error('Submit button not found');
        return;
      }
      
      if (submitBtn.getAttribute('aria-disabled') === 'true') return;
      
      this.handleErrorMessage();
      submitBtn.setAttribute('aria-disabled', true);
      submitBtn.classList.add('loading');
      
      const spinner = this.querySelector('.spinner-loading-btn');
      const buttonText = submitBtn.querySelector('[data-addtocart-text]');
      
      if (spinner) spinner.classList.remove('hidden');
      if (buttonText) buttonText.classList.add('hidden');
      
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname); 
      }
      
      config.body = formData;
      
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form', 
              productVariantId: formData.get('id'), 
              errors: response.description, 
              message: response.message
            });
            this.handleErrorMessage(response.description);
            this.error = true;
            
            if (this.cart) {
              return fetch(`${routes.cart_url}?sections=`+(this.cart.getSectionsToRender().map((section) => section.id)).toString())
                .then(response => response.json())
                .then((response) => {
                  let parsedState = {};
                  parsedState['sections'] = response;
                  this.cart.renderContents(parsedState);          
                });
            }
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          
          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form', 
              productVariantId: formData.get('id')
            });
          }
          this.error = false;
          
          if(this.cart){
            if(document.querySelector(".product-cart-sticky")){
              document.querySelector(".product-cart-sticky").classList.remove("active");
              document.querySelector(".product-cart-sticky .product-cart-sticky-detail")?.classList.remove("active");
            }
            this.cart.renderContents(response);
            this.cart.classList.add("open");
            document.querySelector("body").classList.add("no-scroll");
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          // CAMBIO: Volver a obtener referencia fresca del botón
          const finalSubmitBtn = this.submitButton;
          if (finalSubmitBtn) {
            finalSubmitBtn.classList.remove('loading');
            finalSubmitBtn.removeAttribute('aria-disabled');
            
            const finalButtonText = finalSubmitBtn.querySelector('[data-addtocart-text]');
            if (finalButtonText) finalButtonText.classList.remove('hidden');
          }
          
          const finalSpinner = this.querySelector('.spinner-loading-btn');
          if (finalSpinner) finalSpinner.classList.add('hidden');
          
          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}